import { Component } from '@angular/core';

@Component({
    selector: 'app-monitoring-mode-dialog',
    templateUrl: './monitoring-mode-dialog.component.html',
    styleUrls: ['./monitoring-mode-dialog.component.scss']
})
export class MonitoringModeDialogComponent {}
